<template>
  <div class="wrapper-card border-container cluster-info">
    <div
      class="card-element"
      v-for="(card, cardIndex) in cardNames"
      :key="cardIndex"
    >
      <InfoStats
        class="info-border"
        :textLabel="card"
        :textValue="clusterInfo[cardIndex]"
        fontSize="1rem"
        textValHeight="3rem"
        lineHeight="1.2rem"
        :textValColor="cardValueColor(clusterInfo, cardIndex)"
      />
    </div>
  </div>
</template>

<script>
import * as constants from '@/utils/templates/databaseTemplate/database.constants';
import InfoStats from '@/rex-components/rex-info-stats.vue';

export default {
  name: 'MSSQLInfoCards',
  components: {
    InfoStats,
  },
  props: {
    clusterInfo: {
      type: Object,
      default: () => ({}),
    },
    cardNames: {
      type: Array,
      default: () => [],
    },
    cardWidth: {
      type: String,
      default: () => '15%',
    },
  },
  methods: {
    cardValueColor(arr, index) {
      if (arr[index] === constants.ACTIVE || arr[index] === constants.ONLINE)
        return 'good';
      else if (
        arr[index] === constants.INACTIVE ||
        arr[index] === constants.OFFLINE
      )
        return 'poor';
      else return 'fair';
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper-card {
  @include flex-center-justify(space-between);
  gap: 1rem;
  width: 100%;
}
.card-element {
  margin-top: 0.125em;
  margin-left: 0.125em;
  border-radius: 0.5rem;
  height: 6rem;
  flex: 1;
}

.info-border {
  border-radius: 1rem;
}

.info-wrapper {
  display: flex;
}

.border-container {
  border: 0.125rem solid $color-brand-accent;
  padding: 1.25rem;
  position: relative;
  height: fit-content;
}
.border-container::after {
  content: ' Cluster info ';
  position: absolute;
  top: -0.9375rem;
  left: 10%;
  transform: translateX(-50%);
  background-color: $bg-primary;
  padding: 0.125rem;
  font-weight: bold;
  color: $color-brand-accent;
  border-radius: 0.25rem;
}
.cluster-info::after {
  content: 'Cluster Info';
}
</style>
